/**
 * Filename: message 消息提示UI
 * Created Date:2021/9/24
 * Author: pyh
 * Modifier: 
 *
 * Copyright (c) 2021 Your Company
 */

import success from '@/assets/img/message/success.svg';
import warning from '@/assets/img/message/warning.svg';
import error from '@/assets/img/message/error.svg';

/**
 *  根据UI场景二次封装 message组件，使用方法如下：
 * this.$message({
        type: '', // type 传空字符串
        duration: 1000, // 显示时间, 毫秒。设为 0 则不会自动关闭
        dangerouslyUseHTMLString: true, 是否将 message 属性作为 HTML 片段处理
        center: true, // 文字是否居中
        // message: this.tips.success('success'), // 成功
        // message: this.tips.warning('warning'), // 警告
        // message: this.tips.error('error'), // 错误
        // message: this.tips.info('info'), // 没有icon提示
    })
 * 
 */
export default {
    success(message) {
        let str = `<div class="disp_ac"><img class="mr10" src=${success}> <span>${message}</span></div>`;
        return str;
    },
    warning(message) {
        let str = `<div class="disp_ac"><img class="mr10" src=${warning}> <span>${message}</span></div>`;
        return str;
    },
    info(message) {
        let str = `${message}`;
        return str;
    },
    error(message) {
        let str = `<div class="disp_ac"><img class="mr10" src=${error}> <span>${message}</span></div>`;
        return str;
    }
}